import { useAuth } from "@sal/authentication.react";
import { HttpService, usePortalApplicationContext } from "@sal/onevent-portal";
import { useEffect } from "react";
function App({ children }: React.PropsWithChildren) {
	const auth = useAuth();
	const portalAppContext = usePortalApplicationContext();
	const { startup, shutdown } = portalAppContext.impersonation;

	useEffect(() => {
		startup();
	},[startup]);
	
	HttpService.configure({
		unAuthorizedResponseHandler: () => {
			shutdown();
			auth.logout();
		}
	});
	return children;
}
export default App;